
CheckoutV2.Payment.CreditCardWrap = function(checkout, payment, isReview) {
	ccwrap = this;

	this.$wrap =
	this.$container =
	this.$note =
		false;
    this.reviewSelector = '.';
    if (isReview)
       this.reviewSelector += 'review-';

	this.init = function() {
		ccwrap.$wrap = $(ccwrap.reviewSelector + 'payment-method-creditcard-wrap');
		ccwrap.$container = ccwrap.$wrap.find(ccwrap.reviewSelector + 'payment-method-creditcard-container');
	};

	this.remove = function() {
		ccwrap.$wrap.remove();
	};

	this.init();
};
